module.exports = "/assets/98b62e452bdba4013beafd7117fbece0.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/6E.png
// module id = 1082
// module chunks = 0